// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  userId: __t.string().name("user_id"),
  email: __t.string(),
  name: __t.string(),
  avatarUrl: __t.string().name("avatar_url"),
  isSuperadmin: __t.bool().name("is_superadmin"),
  suspended: __t.bool(),
  impersonatedBy: __t.string().name("impersonated_by"),
  online: __t.bool(),
  createdAt: __t.timestamp().name("created_at"),
  lastSeenAt: __t.timestamp().name("last_seen_at"),
});
